/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { CmlContent } from '__generated__/graphql-types-do-not-use';

import { CheckIcon } from '@coursera/cds-icons';

import CML from 'bundles/unified-description-page-common/components/shared/CML';

type Props = {
  objective: CmlContent;
};

const styles = {
  objective: () => css`
    display: flex;
    flex-direction: row;
    gap: var(--cds-spacing-150);
  `,
  icon: () => css`
    flex-shrink: 0;
  `,
};

// This component renders one single learning objective
const LearningObjective = ({ objective }: Props) => {
  return (
    <div css={styles.objective}>
      <CheckIcon size="large" css={styles.icon} />
      <CML cml={objective} />
    </div>
  );
};

export default LearningObjective;
